import { graphql } from 'react-relay';
import { getExternalCollaboratorEntitlementFromQuery } from '@confluence/external-collab-ui/entry-points/getExternalCollaboratorEntitlementFromQuery.ts';

import type { useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery as useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data } from './__types__/useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useIsEntitledExternalCollaborator = ({
	skip = false,
}: {
	skip?: boolean;
} = {}): {
	isEntitledExternalCollaboration: boolean;
	loading: boolean;
} => {
	const { loading, data } =
		useQueryInterop<useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data>(
			graphql`
				query useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery {
					entitlements {
						externalCollaborator {
							isEntitled
						}
					}
				}
			`,
			{
				skip,
			},
		);
	return {
		isEntitledExternalCollaboration: getExternalCollaboratorEntitlementFromQuery(data) ?? false,
		loading,
	};
};
